/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppNumber.vue?vue&type=template&id=268c9076"
import script from "./AppNumber.ts?vue&type=script&lang=ts&external"
export * from "./AppNumber.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports